import {
    CREATE_FORM_FIELD,
    GET_FORM_FIELDS,
    UPDATE_FORM_FIELD,
    DELETE_FORM_FIELD
} from '../actions/Formfields.action';

const initialState = {
    addFormField: '',
    getFormFields: '',
    updateFormField: '',
    deleteFormField: ''
}

const FormFieldsReducer = (state = initialState, action) => {
    switch (action.type) {
        case CREATE_FORM_FIELD:
            return { ...state, addFormField: action.payload }
        case GET_FORM_FIELDS:
            return { ...state, getFormFields: action.payload }
        case UPDATE_FORM_FIELD:
            return { ...state, updateFormField: action.payload }
        case DELETE_FORM_FIELD:
            return { ...state, deleteFormField: action.payload }
        default:
            return { ...state }
    }
}
export default FormFieldsReducer
